<div class="fft">

  <div class="fft-card">

    <!-- Busca por rota/tela -->
    <div class="fft-search" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
      <mat-form-field appearance="outline" class="fft-search-field">
        <mat-icon matPrefix>search</mat-icon>
        <input
          matInput
          class="fft-search-input"
          placeholder="Buscar permissão..."
          [(ngModel)]="searchText"
          [ngModelOptions]="{ standalone: true }" />
        <button
          *ngIf="isSearching"
          mat-icon-button
          matSuffix
          type="button"
          class="fft-search-clear"
          (click)="clearSearch()"
          matTooltip="Limpar busca">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <!-- Resumo LOCAL da árvore (universo mapeado em tela). O contador
           central `.selected-count`, comum aos dois modos, vive no host
           `app-permission-selection` — aqui ele seria um segundo elemento com
           outro texto e a âncora deixaria de ser única. -->
      <span class="fft-summary">
        {{ totalSelectedCount }} de {{ totalIdsCount }} permissões selecionadas · {{ screensWithSelectionCount }} tela(s)
      </span>
    </div>

    <!-- Toolbar: expandir/recolher tudo + drill-down front/back (visão de suporte) -->
    <!-- Expandir/Recolher tudo é NAVEGAÇÃO (não muda seleção) — nunca gateado por
         [disabled], senão a árvore fica ilegível no modo somente-leitura (perfil,
         ponto 4): o usuário não conseguiria nem VISUALIZAR as próprias permissões
         além do primeiro nível auto-expandido (ver UPD-6/UPD-7). -->
    <div class="fft-toolbar" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
      <button type="button" class="fft-btn" (click)="expandAll()">
        <mat-icon>unfold_more</mat-icon>
        Expandir tudo
      </button>
      <button type="button" class="fft-btn" (click)="collapseAll()">
        <mat-icon>unfold_less</mat-icon>
        Recolher tudo
      </button>
      <!-- Drill-down front/back de TODAS as ações de uma vez (visão de suporte).
           O rótulo NÃO muda quando ligado — só o estado visual (.fft-btn-active)
           e o ícone: é o mesmo botão que liga e desliga, e trocar o texto faria
           o usuário (e a âncora) perder o alvo no segundo clique. -->
      <button
        type="button"
        class="fft-btn"
        [class.fft-btn-active]="showBackMapping"
        [attr.aria-pressed]="showBackMapping"
        (click)="toggleBackMapping()">
        <mat-icon>{{ showBackMapping ? 'visibility' : 'visibility_off' }}</mat-icon>
        Mostrar mapeamento back
      </button>
    </div>

    <!-- Carregando -->
    <div *ngIf="loading" class="fft-loading" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
      <mat-spinner diameter="20"></mat-spinner>
      <span>Carregando árvore de permissões...</span>
    </div>

    <!-- Árvore -->
    <div *ngIf="!loading" class="fft-tree">
      <ng-container *ngIf="visibleGroups.length > 0; else fftEmpty">
        <ng-container *ngFor="let group of mainGroups; trackBy: trackByGroupKey">
          <ng-container *ngTemplateOutlet="groupTpl; context: { group: group }"></ng-container>
        </ng-container>

        <!--
          Nós `advancedOnly` (ações de back SEM tela — o catch-all do motor: webhooks, tenants, roles de
          front sem tela…): ficam AGRUPADOS no fim, sob um nó RECOLHIDO e visualmente distinto, em vez de
          parecerem telas do menu. Só apresentação: contagens, seleção e ids são os mesmos de antes.
        -->
        <div
          *ngIf="systemOnlyGroups.length > 0"
          class="fft-system-only"
          [class.open]="isExpanded(systemOnlyKey) || isSearching">
          <div class="fft-system-only-row" (click)="toggleExpand(systemOnlyKey)">
            <mat-icon class="fft-caret">{{ (isExpanded(systemOnlyKey) || isSearching) ? 'expand_more' : 'chevron_right' }}</mat-icon>
            <mat-icon class="fft-group-icon fft-system-only-icon">settings_suggest</mat-icon>
            <span class="fft-group-name fft-system-only-name">{{ systemOnlyLabel }}</span>
            <span class="fft-system-only-badge">SEM TELA</span>
            <span class="fft-count">{{ systemOnlySelectedCount }} de {{ systemOnlyIdsCount }}</span>
          </div>
          <div class="fft-system-only-body" *ngIf="isExpanded(systemOnlyKey) || isSearching">
            <div class="fft-system-only-note">
              Permissões de sistema que não pertencem a nenhuma tela do menu (webhooks, integrações, infraestrutura…).
              Continuam valendo e podem ser marcadas normalmente.
            </div>
            <ng-container *ngFor="let group of systemOnlyGroups; trackBy: trackByGroupKey">
              <ng-container *ngTemplateOutlet="groupTpl; context: { group: group }"></ng-container>
            </ng-container>
          </div>
        </div>
      </ng-container>
      <!-- Nível 1: GRUPO (reusado pelos grupos do menu e pelos do nó "sem tela") -->
      <ng-template #groupTpl let-group="group">
        <div
          class="fft-group"
          [class.open]="isExpanded(group.key) || isSearching">

          <!-- Nível 1: GRUPO -->
          <div class="fft-group-row" (click)="toggleExpand(group.key)">
            <mat-icon class="fft-caret">{{ (isExpanded(group.key) || isSearching) ? 'expand_more' : 'chevron_right' }}</mat-icon>
            <mat-checkbox
              class="fft-cb"
              [checked]="isGroupChecked(group)"
              [indeterminate]="isGroupIndeterminate(group)"
              [disabled]="disabled"
              (click)="$event.stopPropagation()"
              (change)="toggleGroup(group, $event.checked)">
            </mat-checkbox>
            <mat-icon class="fft-group-icon">{{ groupIcon(group) }}</mat-icon>
            <span class="fft-group-name">{{ group.label }}</span>
            <span class="fft-count">{{ groupSelectedCount(group) }} de {{ group.ids.length }}</span>
          </div>

          <!-- Nível 2+: SUBGRUPOS (telas), profundidade arbitrária via template recursivo -->
          <div class="fft-subs" *ngIf="isExpanded(group.key) || isSearching">
            <ng-container *ngFor="let sub of visibleSubgroups(group); trackBy: trackBySubKey">
              <ng-container
                *ngTemplateOutlet="subgroupTpl; context: { sub: sub, depth: 0 }">
              </ng-container>
            </ng-container>

            <div class="fft-empty-hint" *ngIf="visibleSubgroups(group).length === 0">
              Nenhuma tela encontrada para "{{ searchText }}" neste grupo.
            </div>
          </div>
        </div>
      </ng-template>

      <!--
        Template recursivo de SUBGRUPO — profundidade arbitrária (aninhamento
        recursivo, ver front-first-permission-tree.component.ts). Um subgrupo
        pode ser:
          - uma TELA real (routerLink + actions), folha ou com sub-telas;
          - um CONTAINER organizacional (sem routerLink/actions próprias, só
            `children` — ex.: a pasta "PRODUTOS" que agrupa Categorias/Marcas/
            Sub-categorias/Tributos/NCM/Unidades) — mesmo assim expande/
            recolhe e cascateia o tri-state (ids já vêm agregados do backend).
        `depth` cresce 1 por nível — usado só pra indentação progressiva.
      -->
      <ng-template #subgroupTpl let-sub="sub" let-depth="depth">
        <div
          class="fft-sub"
          [class.fft-sub-container]="hasChildren(sub) && sub.actions.length === 0"
          [class.open]="isSubgroupExpanded(sub.key) || isSearching">

          <div
            class="fft-sub-row"
            [style.padding-left.px]="subIndent(depth)"
            (click)="toggleSubgroupExpand(sub.key)">
            <mat-icon class="fft-caret">{{ (isSubgroupExpanded(sub.key) || isSearching) ? 'expand_more' : 'chevron_right' }}</mat-icon>
            <mat-checkbox
              class="fft-cb fft-cb-sm"
              [checked]="isSubgroupChecked(sub)"
              [indeterminate]="isSubgroupIndeterminate(sub)"
              [disabled]="disabled"
              (click)="$event.stopPropagation()"
              (change)="toggleSubgroup(sub, $event.checked)">
            </mat-checkbox>
            <span class="fft-sub-name">{{ sub.label }}</span>
            <span class="fft-pending-badge" *ngIf="sub.pending">NÃO CURADA</span>
            <span class="fft-sub-path">{{ displayPathLabel(sub) }}</span>
            <span class="fft-count">· {{ subgroupSelectedCount(sub) }}/{{ sub.ids.length }}</span>
          </div>

          <!-- Tela sem curadoria de back completa (dado do backend, antes descartado). -->
          <div
            class="fft-sub-note"
            [style.padding-left.px]="subIndent(depth)"
            *ngIf="sub.pending && sub.note && (isSubgroupExpanded(sub.key) || isSearching)">
            <mat-icon class="fft-sub-note-icon">info_outline</mat-icon>
            {{ sub.note }}
          </div>

          <!-- AÇÕES (folhas) desta tela -->
          <div class="fft-actions" *ngIf="(isSubgroupExpanded(sub.key) || isSearching) && sub.actions.length > 0">
            <ng-container *ngFor="let action of sub.actions; trackBy: trackByActionKey">
              <div class="fft-action" [class.fft-action-pending]="sub.pending" [style.padding-left.px]="actionIndent(depth)">
                <mat-checkbox
                  class="fft-cb fft-cb-sm"
                  [checked]="isActionChecked(action)"
                  [indeterminate]="isActionIndeterminate(action)"
                  [disabled]="disabled || action.ids.length === 0"
                  (change)="toggleAction(action, $event.checked)">
                </mat-checkbox>
                <span class="fft-action-name" [matTooltip]="action.description || ''" matTooltipPosition="above">{{ action.label }}</span>
                <span class="fft-tags">
                  <span class="fft-tag fft-tag-front" *ngIf="action.hasFront">front</span>
                  <span class="fft-tag fft-tag-back" *ngIf="action.hasBack">back</span>
                </span>
                <button
                  type="button"
                  class="fft-action-info"
                  matTooltip="Ver os ids reais de front/back desta ação"
                  (click)="toggleActionDetail(action, $event)">
                  <mat-icon>info_outline</mat-icon>
                </button>
              </div>

              <!-- Drill-down front/back: os ids reais já vinham resolvidos no DTO
                   (frontIds/backIds) e não eram exibidos em lugar nenhum. Cada
                   lado mostra chips OU o aviso de ausência — nunca fica mudo. -->
              <div
                class="fft-action-detail"
                *ngIf="isActionDetailOpen(action)"
                [style.margin-left.px]="actionIndent(depth)">
                <div class="fft-detail-row">
                  <span class="fft-detail-key fft-detail-key-front">front</span>
                  <span class="fft-detail-chips" *ngIf="action.frontIds.length > 0; else noFrontIds">
                    <span class="fft-chip fft-chip-front" *ngFor="let id of action.frontIds">{{ id }}</span>
                  </span>
                  <ng-template #noFrontIds>
                    <span class="fft-detail-empty">— sem front —</span>
                  </ng-template>
                </div>
                <div class="fft-detail-row">
                  <span class="fft-detail-key fft-detail-key-back">back</span>
                  <span class="fft-detail-chips" *ngIf="action.backIds.length > 0; else noBackIds">
                    <span class="fft-chip fft-chip-back" *ngFor="let id of action.backIds">{{ id }}</span>
                  </span>
                  <ng-template #noBackIds>
                    <span class="fft-detail-empty">— sem back —</span>
                  </ng-template>
                </div>
              </div>
            </ng-container>
          </div>

          <!-- Sub-telas ANINHADAS (profundidade arbitrária) — mesmo template, 1 nível mais fundo. -->
          <div class="fft-nested" *ngIf="hasChildren(sub) && (isSubgroupExpanded(sub.key) || isSearching)">
            <ng-container *ngFor="let child of visibleChildren(sub); trackBy: trackBySubKey">
              <ng-container
                *ngTemplateOutlet="subgroupTpl; context: { sub: child, depth: depth + 1 }">
              </ng-container>
            </ng-container>
          </div>
        </div>
      </ng-template>

      <ng-template #fftEmpty>
        <div class="fft-empty-state">
          <span *ngIf="isSearching">Nenhum resultado para "{{ searchText }}".</span>
          <span *ngIf="!isSearching">Nenhuma permissão disponível.</span>
        </div>
      </ng-template>
    </div>

    <div class="fft-foot" *ngIf="!loading" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="12px">
      <div class="fft-foot-note">
        Marcar um <strong>grupo</strong> concede tudo abaixo · uma <strong>tela</strong> concede todas as ações dela ·
        uma <strong>ação</strong> é a permissão específica.
      </div>
      <button
        type="button"
        class="fft-btn fft-btn-clear"
        [disabled]="disabled"
        (click)="clearSelection()">
        Limpar
      </button>
    </div>
  </div>
</div>
